import React from "react";
import "./HomeSections.css";
// import SupportImg from "../../assets/Image/6.jpeg"; // add your image
import SupportImg from "../../assets/Image/6.jpg";

function SupportResources() {
  const handleDemoClick = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&to=raghav405@gmail.com&su=Booking Free Demo&body=Hello, I would like to book a free demo session.",
      "_blank",
    );
  };
  return (
    <section className="section-wrapper light-bg">
      <div className="container row valign-wrapper flex-wrap">
        <div className="col l6 s12">
          <h4>Extensive Support & Resources</h4>
          <p>
            Exhaustive career library with details like work description, career
            path, colleges and pros & cons.
          </p>
          <p>
            Expert-written articles, webinars and vlogs on all things career -
            trends, inspiration and guidance.
          </p>
          <p>
            Career e-guides, entrance exam calendars, resume preparation and
            regular updates.
          </p>

          <button className="custom-btn" onClick={handleDemoClick}>
            Take Free Demo
          </button>
        </div>

        <div className="col l6 s12 center">
          <img src={SupportImg} alt="" className="responsive-img custom-img" />
        </div>
      </div>
    </section>
  );
}

export default SupportResources;
